import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../../features/messageActionSlice";
import { MessageType } from "../../../types/messageType";
import { RootState } from "../../../store";

interface props {
  isUser: boolean;
  data: MessageType;
}

const MessageAction = ({ isUser, data }: props) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.messageActionModal.isOpen
  );
  const modalFor = useSelector(
    (state: RootState) => state.messageActionModal.id
  );
  return (
    <div
      className={`${
        !isUser ? "left-full ml-2" : "right-full mr-2"
      } absolute top-1/2 -translate-y-1/2 group-hover:flex w-7 h-7 rounded-full justify-center items-center bg-gray-200 z-50 ${
        isOpen && modalFor === data.id ? "flex" : "hidden"
      }`}
    >
      <div className="relative w-full h-full">
        <button
          className="w-full h-full"
          onClick={() => dispatch(!isOpen ? openModal(data.id) : closeModal())}
        >
          <i className="fa-solid fa-ellipsis-vertical text-slate-500 text-sm"></i>
        </button>
        <div
          className={`w-[120px] p-1 bg-white rounded-md shadow-md absolute bottom-full ${
            isOpen && modalFor === data.id ? "visible" : "invisible"
          } ${isUser ? "right-0" : "left-0"}`}
        >
          <button
            onClick={() => dispatch(closeModal())}
            className="text-xs text-slate-500 w-full p-2 hover:bg-slate-100 text-left"
          >
            Remove
          </button>
          <button
            onClick={() => dispatch(closeModal())}
            className="text-xs text-slate-500 w-full p-2 hover:bg-slate-100 text-left"
          >
            Forward
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageAction;
